import { useTranslation } from 'react-i18next'
import Plate from 'Components/Plate'
import { plateTypeFormat } from 'Application/Visits/Actions/plateType'

interface VisitOtherDataProps {
  data: any
  isDispatch?: boolean
}

const VisitOtherData: React.FC<VisitOtherDataProps> = ({ data, isDispatch }) => {
  const [t] = useTranslation()

  return (
    <>
      <div className="font-bold text-base mt-3">{t('INSURANC_CASE_INFO')}</div>
      <div className="my-2">
        {data?.plateType === 100 ? (
          <div className="text-center text-gray-500 font-bold">بدون پلاک</div>
        ) : (
          <Plate
            disabled
            mode={false}
            showVehicleType={false}
            value={{
              type: plateTypeFormat(data?.plateType),
              carOtherNumber: data?.plateCarOtherNumber,
              carSerial: data?.plateCarSerial,
              char: data?.plateChar,
              cityCode: data?.plateCityCode,
              motorCycleOtherNumber: data?.plateAdditionalNumber,
              motorCycleSerial: data?.plateMotorCycleSerial,
              isDisabled: plateTypeFormat(data?.plateType) === 'FREEZONE',
            }}
          />
        )}
      </div>

      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('VEHICLE_TYPE')}:</span>
        <span className="text-sm font-semibold text-gray-800">{data?.vehicleTypeTitle}</span>
      </div>
      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('HAS_CARGO_ROOM')}:</span>
        <span className="text-sm font-semibold text-gray-800">
          {data?.cargoCompartmentId ? t('YES_CARGO') : t('NO_CARGO')}
        </span>
      </div>

      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('VEHICLE_BRAND')}:</span>
        <span className="text-sm font-semibold text-gray-800">{data?.vehicleBrandTitle}</span>
      </div>
      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('VEHICLE_TIP')}:</span>
        <span className="text-sm font-semibold text-gray-800">{data?.vehicleTipTitle}</span>
      </div>
      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('YEAR_OF_CONSTRUCTION')}:</span>
        <span className="text-sm font-semibold text-gray-800">{data?.yearOfConstruction}</span>
      </div>
      {!isDispatch && (
        <div className="flex justify-between items-center gap-2">
          <span className="text-sm text-gray-600">{t('VEHICLE_COLOR')}:</span>
          <span className="text-sm font-semibold text-gray-800">{data?.vehicleColorTitle}</span>
        </div>
      )}
      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('VEHICLE_USAGE')}:</span>
        <span className="text-sm font-semibold text-gray-800">{data?.vehicleUsageTitle}</span>
      </div>
      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('CHASSIS_NUMBER')}:</span>
        <span className="text-sm font-semibold text-gray-800">{data?.chassisNumber}</span>
      </div>
      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('ENGINE_NUMBER')}:</span>
        <span className="text-sm font-semibold text-gray-800">{data?.engineNumber}</span>
      </div>
    </>
  )
}

export default VisitOtherData
